export default {
  create: "Add an email account",
}
